<script>
	const actualTime = new Date().getHours();
	const actualYear = new Date().getFullYear();
	const day = actualTime > 8 && actualTime < 19;
	import Tailwindcss from "./Tailwind.svelte";
	import Title from "./components/Title.svelte";
	import Projet from "./components/Projet.svelte";
	import Contacts from "./components/Contacts.svelte";
	import projects from "./projects";
	import Container from "./components/base/Container.svelte";
</script>

<Tailwindcss />

<Container
	className="bg-gradient-to-b from-primary via-primary/50 to-primary/20 text-secondary flex-col min-h-screen"
	id="title"
>
	<div class="grow flex justify-center sm:justify-between flex-col-reverse sm:flex-row align-middle items-center">
		<Title
			title={day ? "Bonjour 👋" : "Bonsoir 💤"}
			subtitle={day
				? "Moi c'est Romain, développeur full-stack, Node.Js, React.Js et Vue.Js. Découvrez mes projets\n\nEt si on travaillait ensemble ? 🤝"
				: "Moi c'est Romain, développeur full-stack, Node.Js, React.Js et Vue.Js. Découvrez mes projets\n\nOn commence dès demain ? 😴"}
			className="w-full sm:w-3/5 lg:w-1/2 2xl:w-2/5 grow sm:grow-0 h-1/2"
		/>
		<div class="flex items-center grow sm:grow-0 h-1/2">
			<img
				src={day
					? "assets/images/apple-pp.webp"
					: "assets/images/apple-pp-sleep.webp"}
				alt="Profile Romain"
				class="h-32 w-32 sm:h-36 sm:w-36 md:h-44 md:w-44 lg:h-56 lg:w-56 xl:h-64 xl:w-64 2xl:h-72 2xl:w-72 3xl:h-96 3xl:w-96"
			/>
		</div>
	</div>
	<div>
		<a
			href="#about"
			class="block border border-secondary p-4 rounded-full animate-bounce -mb-8"
			aria-label="Voir la suite"
		>
			<i class="fa-solid fa-chevron-down fa-2x" />
		</a>
	</div>
</Container>
<Container
	className="bg-gradient-to-b from-primary via-primary/50 to-primary/20 text-secondary flex-col justify-center"
	title="À propos"
	id="about"
>
	<Contacts />
</Container>
<Container
	className="bg-gradient-to-t from-primary via-primary/50 to-primary/20 text-secondary relative flex-col justify-center min-h-screen"
	title="Projets"
	id="projects"
>
	<div class="grid grid-cols-1 gap-24 sm:gap-16 lg:grid-cols-2 3xl:grid-cols-3 mt-8">
		{#each projects as project}
			<Projet {...project} />
		{/each}
	</div>
</Container>
<Container
	className="bg-gradient-to-t from-primary via-primary/50 to-primary/20 text-secondary flex justify-between"
	id="footer"
>
	<p class="shrink">© {actualYear}, Romain Neuplanche</p>
	<p>Fait à Paris avec ♥︎</p>
</Container>
